export default __webpack_public_path__ + "static/media/type-56.26b3f338.svg";